@import '@hevoio/hevo-ui-toolkit/styles/variables';

.modalPaper {
  background: $surface-bg !important;
}

.setupGuideDocs {
  width: 40%;
  min-width: 360px;
  border-left: 1px solid $stroke-soft-200;
}